import {useState} from 'react';
import {FontItem} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/Dropdown/FontItem/FontItem';
import {getFontName} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/Dropdown/utils';
import {Accordion} from '~library/molecules/Accordion';
import {ChevronIcon} from '~library/svg/ChevronIcon';
import {emeraldWebText} from '~libSass/base/_exports.sass';

import './AllFonts.sass';
export function AllFonts({onClick, selectedFont, allFonts}) {
  const [openAccordions, setOpenAccordions] = useState({});

  const handleAccordionToggle = (family) => {
    setOpenAccordions((prev) => ({
      ...prev,
      [family]: !prev[family],
    }));
  };

  return allFonts.map((font) => {
    const isSimple =
      font.styles.length === 1 &&
      font.styles[0] === 'normal' &&
      font.weights.length === 1 &&
      font.weights[0] === '400';

    if (isSimple) {
      const formattedFont = {
        name: getFontName(font, 'normal', '400') || font.family,
        family: font.family,
        style: 'normal',
        weight: '400',
        type: font.type,
      };
      return (
        <FontItem
          key={font.family}
          font={formattedFont}
          onClick={onClick}
          selected={formattedFont.name === selectedFont?.name}
          isSimple={true}
        />
      );
    }

    const isFamilySelected = font.styles.some((style) =>
      font.weights.some((weight) => {
        const name = getFontName(font, style, weight) || font.family;
        return (
          name === selectedFont?.name &&
          style === selectedFont?.style &&
          weight === selectedFont?.weight
        );
      })
    );

    const isSelectedAndClosed = isFamilySelected && !openAccordions[font.family];

    return (
      <Accordion
        label={font.family}
        customLabelElement={
          <div
            style={{
              fontWeight: font.weights[0],
              fontFamily: font.family,
              fontStyle: font.styles[0],
              fontSize: '1rem',
              ...(isSelectedAndClosed ? {color: emeraldWebText} : {}),
            }}
          >
            {font.family}
          </div>
        }
        accordionBodyClassName="font-family-accordion__body"
        accordionButtonClassName="font-family-accordion"
        key={font.family}
        isOpen={false}
        className={isSelectedAndClosed ? 'accordion--selected' : ''}
        onOpen={() => handleAccordionToggle(font.family)}
        onClose={() => handleAccordionToggle(font.family)}
        arrowPlacement="left"
        chevron={
          <ChevronIcon
            className={isSelectedAndClosed ? 'font-chevron-icon' : ''}
            direction={openAccordions[font.family] ? 'down' : 'right'}
            ratio={0.5}
          />
        }
      >
        {font.styles.map((style) =>
          font.weights.map((weight) => {
            const formattedFont = {
              name: getFontName(font, style, weight) || font.family,
              family: font.family,
              style,
              weight,
              type: font.type,
            };
            return (
              <FontItem
                key={`${font.family}_${style}_${weight}`}
                font={formattedFont}
                onClick={onClick}
                selected={formattedFont.name === selectedFont?.name}
              />
            );
          })
        )}
      </Accordion>
    );
  });
}
